module.exports = __webpack_public_path__ + "static/media/JS3.43be4942.PNG";